import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadBuchungsPostenListStatus: 'idle',
    loadBuchungsPostenListError: undefined as any,
    loadBuchungsPostenListLastArgs: undefined as any,

    buchungsPostenList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadBuchungsPostenList = createAsyncThunk('auftragBuchungsPostenSlice/loadBuchungsPostenList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragBuchungsPostenSlice.loadBuchungsPostenListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/vkontobuchungen/?action=gte&MIN_AUFTRAGID=${parentModel.HDR_ID}&MAX_AUFTRAGID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadBuchungsPostenListStatus } = getState().auftragBuchungsPostenSlice
        return loadBuchungsPostenListStatus !== 'pending'
    }
})

const BuchungsPostenSlice = createSlice({
    name: 'auftragBuchungsPostenSlice',
    initialState,
    reducers: {
        resetloadBuchungsPostenListError: (state) => {
            state.loadBuchungsPostenListError = undefined
        },
        removeFromBuchungsPostenListById: (state, action) => {
            state.buchungsPostenList = state.buchungsPostenList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromBuchungsPostenListByIds: (state, action) => {
            state.buchungsPostenList = state.buchungsPostenList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.buchungsPostenList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadBuchungsPostenListStatus = 'preloaded'
            state.loadBuchungsPostenListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.buchungsPostenList = []
            state.loadBuchungsPostenListStatus = 'idle'
            state.loadBuchungsPostenListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadBuchungsPostenList.pending, (state) => {
            state.loadBuchungsPostenListStatus = 'pending'
            state.loadBuchungsPostenListError = undefined
        })
        builder.addCase(loadBuchungsPostenList.fulfilled, (state, action) => {
            state.loadBuchungsPostenListStatus = 'idle'

            if (!action.payload) { return }

            state.loadBuchungsPostenListLastArgs = action.payload.args

            {
                state.buchungsPostenList = action.payload.data

            }
        })
        builder.addCase(loadBuchungsPostenList.rejected, (state, action) => {
            state.loadBuchungsPostenListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadBuchungsPostenListError = action.error.message
            } else {
                state.loadBuchungsPostenListError = action.payload
            }
        })

    }
})

export const {
    resetloadBuchungsPostenListError,
    removeFromBuchungsPostenListById,
    removeFromBuchungsPostenListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = BuchungsPostenSlice.actions
export default BuchungsPostenSlice.reducer
